var texts = {
  'sv-SE': {
    guestRating: 'Betyg från Vings gäster',
    guestRatingShort: 'Gästbetyg'
  },
  'nb-NO': {
    guestRating: 'Vurdering fra Vings gjester',
    guestRatingShort: 'Gjestevurdering'
  },
  'da-DK': {
    guestRating: 'Bedømmelse fra Spies gæster',
    guestRatingShort: 'Gæstebedømmelse'
  },
  'fi-FI': {
    guestRating: 'Asiakkaidemme arviot',
    guestRatingShort: 'Vierasarvio'
  },
  en: {
    guestRating: 'Guest rating',
    guestRatingShort: 'Guest rating'
  }
};
var texts$1 = texts;

export { texts$1 as default };
//# sourceMappingURL=GuestRating.texts.js.map
